// import $ from 'jquery';
import BaseAction from './base.js';
import drawerInit from './instance-builders/selector-drawer.js';
import popupInit from './instance-builders/selector-popup.js';
import { closeAllExceptThis, headerTippyInstances } from './instance-builders/shared-objects.js';
import { getOptionsFromDataset } from '../../../util/dom.js';

export default class CartAction extends BaseAction {

	/**
	 * @param {JQuery} $container
	 */
	async init($container) {

		const $selectorTriggers = $container.find('[data-toggle-selector]');

		for (const triggerElem of $selectorTriggers) {

			// Get dataset options
			const options = getOptionsFromDataset(triggerElem, 'toggleSelector', true);
			const mode = (options.modeMobile && mpro.isMobileScreen()) || options.mode;

			switch (mode) {

				// Load in popup
				case 'popup': {

					const $triggerElem = $(triggerElem);
					// Make sure attrs with href are not executed
					$triggerElem.on('click', (e) => {
						e.preventDefault();
					});

					// eslint-disable-next-line no-await-in-loop
					const instance = await popupInit($triggerElem, $triggerElem.parent(), $triggerElem.next(), {
						onTrigger: closeAllExceptThis,
					});

					headerTippyInstances.add(instance);
					break;
				}

				// Default to 'drawer'
				default: {

					// Init triggers that open the cart drawer (no tippy instance)
					drawerInit(triggerElem, options);
				}
			}
		}
	}
}
